import {Component, OnInit} from '@angular/core';
import {CommonService} from '../_services';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-exceedance-report-list',
  templateUrl: './exceedance-report-list.component.html',
  styleUrls: ['./exceedance-report-list.component.css']
})
export class ExceedanceReportListComponent implements OnInit {

  route: string;
  firstLevelExceedance: any = [];
  exceedanceIndustryList = [];
  industryParameterCount = [];
  exceedanceIndustryHistory = [];
  regionList = [];
  regionFilter = '';
  selectedOfficerNameExceedance = '';
  selectedRegionNameExceedance = '';
  moreDetailDrilledExceedance = false;
  selectedIndustryNameExceedance = '';
  selectedIndustryAddressExceedance = '';
  regionLoaderExceedance = false;
  industryLoaderExceedance = false;
  historyLoaderExceedance = false;
  public apiBaseUrl: string = environment.apiBaseUrl;
  startReportDate: Date;
  endReportDate = new Date();
  currentReportDate = new Date();
  oneDayBeforeDate = new Date();
  maxStartDate: Date;
  maxEndDate: Date;

  startReportTime: Date;
  endReportTime: Date;

  startDate = '';
  endDate = '';
  startTime = '';
  endTIme = '';

  userData: any = [];

  userName;
  userLevel;
  searchField = {};

  i = 0;

  constructor(private activeroute: ActivatedRoute, private router: Router,
              private _service: CommonService) {

    this.maxStartDate = new Date();
    this.maxEndDate = new Date();

  }

  ngOnInit() {

    var d = new Date();
    d.setDate(d.getDate());
    this.startReportDate = d;

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if (this.userData) {
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if (this.userLevel == 'industry') {
      this.searchField['industryId'] = this.userName;
    }

    if (this.userLevel == 'vendor') {
      this.searchField['vendorId'] = this.userData['id'] ? this.userData['id'] : '';
    }

    if (!this.i) {
      this.getExceededIndustry();
    }
    this.getRegionList();
  }


  onStartDateChange(value: Date): void {
    this.startReportDate = value;
  }

  onEndDateChange(value: Date): void {
    this.endReportDate = value;
  }

  getRegionList() {

    this.route = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if (response.status == 200) {
        this.regionList = response.data;
        this.regionFilter = response.data[0].region_name;
        if (this.i == 0) {
          this.getExceededIndustry();
          this.i = 1;
        }
      }
    });
  }


  getExceededIndustry() {

    if (this.startReportDate) {
      this.startDate = this.convertDateFormat(this.startReportDate);
    }

    if (this.endReportDate) {
      this.endDate = this.convertDateFormat(this.endReportDate);
    }

    if (this.startReportTime) {
      this.startTime = this.convertTimeFormat(this.startReportTime);
    }

    if (this.endReportTime) {
      this.endTIme = this.convertTimeFormat(this.endReportTime);
    }

    this.regionLoaderExceedance = true;
    this.route = 'get-exceeded-industry-region-wise';
    const token = localStorage.getItem('userToken');

    let data = {
      'region': this.regionFilter,
      'startDate': this.startDate,
      'endDate': this.endDate,
      'startTime': this.startTime,
      'endTIme': this.endTIme,
      'search_fields': this.searchField
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.firstLevelExceedance = response.result;
      }
      this.regionLoaderExceedance = false;
    });
  }

  getExceedanceIndustryList(regionName, officerName) {

    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedRegionNameExceedance = regionName;
    this.selectedOfficerNameExceedance = officerName;

    this.route = 'get-exceedance-industry-list';
    const token = localStorage.getItem('userToken');

    let data = {
      'region_name': regionName,
      'startDate': this.startDate,
      'endDate': this.endDate,
      'startTime': this.startTime,
      'endTIme': this.endTIme,
      'search_fields': this.searchField
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.exceedanceIndustryList = response.data;
        this.industryParameterCount = response.total_parameter_ind_count;
      }
      this.industryLoaderExceedance = false;
    });
  }

  getIndustryExceedanceHistory(industryName, industryAddress, industryId) {

    this.historyLoaderExceedance = true;
    this.moreDetailDrilledExceedance = true;
    this.selectedIndustryNameExceedance = industryName;
    this.selectedIndustryAddressExceedance = industryAddress;

    this.route = 'get-industry-exceedance-history';
    const token = localStorage.getItem('userToken');

    let data = {
      'industry_id': industryId,
      'startDate': this.startDate,
      'endDate': this.endDate,
      'startTime': this.startTime,
      'endTIme': this.endTIme
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.exceedanceIndustryHistory = response.data;
      }
      this.historyLoaderExceedance = false;
    });
  }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);

    var str = result_date.getFullYear() + '-' +
      ((result_date.getMonth() + 1) > 9 ? (result_date.getMonth() + 1) : ('0' + (result_date.getMonth() + 1)))
      + '-' +
      (result_date.getDate() > 9 ? result_date.getDate() : ('0' + result_date.getDate()));

    return str;
  }

  convertTimeFormat(timeObj) {

    if (timeObj) {
      var result_time = new Date(timeObj);

      return ((result_time.getHours()) > 9 ? (result_time.getHours()) : ('0' + (result_time.getHours()))) + ':' + ((result_time.getMinutes()) > 9 ? (result_time.getMinutes()) : ('0' + (result_time.getMinutes()))) + ':00';
    } else {
      return '00:00:00';
    }
  }

  backToPreviousLevelExceedance() {
    this.moreDetailDrilledExceedance = false;
  }

  industrySum() {
    let industrySum = 0;
    for (const property in this.firstLevelExceedance) {
      let innerObject = this.firstLevelExceedance[property];

      for (const innerProperty in innerObject) {
        let object = innerObject[innerProperty];
        industrySum += object.industry_count;
      }
    }
    return industrySum;
  }

  exceedanceIndustrySum() {
    let industrySum = 0;
    for (const property in this.firstLevelExceedance) {
      let innerObject = this.firstLevelExceedance[property];

      for (const innerProperty in innerObject) {
        let object = innerObject[innerProperty];
        industrySum += object.exceedance_count;
      }
    }
    return industrySum;
  }

  exportReport(fileType) {
    if (!this.startReportDate) {
      this.startReportDate = new Date();
    }

    if (!this.endReportDate) {
      this.endReportDate = new Date();
    }
    var start_date = this.convertDateFormat(this.startReportDate);
    var end_date = this.convertDateFormat(this.endReportDate);
    var a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export' + fileType + 'href');

    a.href = this.apiBaseUrl + '/get-exceeded-industry-region-wise-export/' + fileType + '/' + token
      + '?region=' + (this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      + '&startDate=' + (this.startDate ? btoa(this.startDate) : btoa(null))
      + '&endDate=' + (this.endDate ? btoa(this.endDate) : btoa(null))
      + '&startTime=' + (this.startTime ? btoa(this.startTime) : btoa(null))
      + '&endTIme=' + (this.endTIme ? btoa(this.endTIme) : btoa(null))
      + '&search_fields=' + (this.searchField ? btoa(JSON.stringify(this.searchField)) : btoa(null));
    document.getElementById('export' + fileType + 'href').click();
  }

  getParameterPercentageList(industry: any): { key: string; value: number }[] {
    const percentages = industry.parameter_percentages || {};
    return Object.keys(percentages).map(key => ({
      key,
      value: percentages[key]
    }));
  }


}
